import { HugeiconsIcon } from "@hugeicons/react";
import { ArrowDown01Icon } from "@hugeicons-pro/core-stroke-rounded";
import { Button, CollapsibleTrigger } from "@workspace/frontend-ui";
import type { FC } from "react";

type Props = {
  label: string;
};

const ChevronButton: FC<Props> = ({ label }) => (
  <CollapsibleTrigger asChild>
    <Button
      variant="secondary"
      size="icon-sm"
      aria-label={label}
      className="rounded-full border-solid border-t border-t-foreground/10 bg-foreground/10 text-foreground backdrop-blur-md hover:bg-foreground/20 data-[state=open]:[&_svg]:rotate-180 [&_svg]:size-3.5 [&_svg]:transition-transform"
    >
      <HugeiconsIcon icon={ArrowDown01Icon} />
    </Button>
  </CollapsibleTrigger>
);

export default ChevronButton;
